module.exports = __webpack_public_path__ + "media/video3.a3cbff9f.mp4";